import { render, staticRenderFns } from "./Wp_jd_skulist_with_url_filter.vue?vue&type=template&id=73680deb&scoped=true&"
import script from "./Wp_jd_skulist_with_url_filter.vue?vue&type=script&lang=js&"
export * from "./Wp_jd_skulist_with_url_filter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73680deb",
  null
  
)

export default component.exports